import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {Configuration} from '../../configuration';

import {ModalController, Platform} from '@ionic/angular';
import {Router} from '@angular/router';

import {BaseService} from '../base.service';
import {Storage} from '@ionic/storage';
import {User} from '../../models/comons/entities/User';
import {AuthResponse, JwtAuthenticationRequest, ResetRequest, SignupModel, VerifyRequest} from '../../models/comons/dto/Authentication';
import {ResponseModel} from '../../models/comons/dto/ResponseModel';
import {Package} from '../../models/comons/entities/Package';
import {PackageService} from '../package-service/package.service';
import {AlertService} from '../alert/alert.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService extends BaseService {
    refreshInfo: BehaviorSubject<number> = new BehaviorSubject<number>((new Date()).getTime());
    user: User;
    token: string = '';
    userInformationLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    currentPackageInfo: Package;
    currentPackageSubject=new BehaviorSubject(null);
    modal: any;


    constructor(private http: HttpClient,
                private platform: Platform,
                private storage: Storage,
                private packageService: PackageService,
                private alertService: AlertService,
                private router: Router) {
        super('uaa');
        // platform.ready().then(() => {
        this.checkAuthenticatedOfStorage();
        // });
    }

    /** check storage for read token **/
    checkAuthenticatedOfStorage() {
        this.storage.get('token').then(res => {
            this.token = res;
            if (res) {
                this.storage.get('current-package').then(cp => {
                    if (cp) {
                        try {
                            this.currentPackageInfo = JSON.parse(cp);
                            this.currentPackageSubject.next(this.currentPackageInfo);
                            console.log(this.currentPackageInfo);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                });
            }
        });
        this.storage.get('user').then(user => {
            if (user) {
                try {
                    this.user = JSON.parse(user);
                    this.userInformationLoaded.next(true);
                } catch (e) {
                    console.error(e);
                }
            }
        });


    }

    isAuthentication(): Promise<boolean> {
        return new Promise(resolve => {
            this.storage.get('token').then(token => {
                console.log(token);
                if (token) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }

    /** send request for input token  **/
    login(jwtAuthenticationRequest: JwtAuthenticationRequest):
        Observable<ResponseModel<AuthResponse>> {
        return this.http.post<ResponseModel<AuthResponse>>
        (`${Configuration.url}/${this.preRoute}/api/auth`, jwtAuthenticationRequest);
    }

    /** return verify code to client  **/
    requestToken(resetRequest: ResetRequest): Observable<ResponseModel<void>> {
        return this.http.post<ResponseModel<void>>
        (`${Configuration.url}/${this.preRoute}/api/auth/reset`, resetRequest);
    }

    /** verify user token (activate) **/
    verifyToken(verifyRequest: VerifyRequest): Observable<ResponseModel<AuthResponse>> {
        return this.http.post<ResponseModel<AuthResponse>>
        (`${Configuration.url}/${this.preRoute}/api/auth/activate`, verifyRequest);
    }

    /** verify user token **/
    refreshAuthenticationToken(): Observable<any> {
        return this.http.post<any>(`${Configuration.url}/${this.preRoute}/api/auth/refresh-token`,
            {});
    }

    /** sign up user  **/
    signUp(signupModel: SignupModel): Observable<ResponseModel<void>> {
        return this.http.post<ResponseModel<void>>
        (`${Configuration.url}/${this.preRoute}/api/auth/signup`, signupModel);
    }

    /** Store user in localstorage **/
    async storeUser(user: any): Promise<void> {
        await this.storage.remove('user');
        return new Promise(resolve => {
            if (user) {
                this.storage.set('user', JSON.stringify(user)).then(() => {
                    this.user = user;
                    this.userInformationLoaded.next(true);
                });
            } else {
                this.storage.remove('token').then();
            }
        });
    }

    /** Store token in localstorage **/
    async storeToken(token: string): Promise<void> {
        return new Promise(resolve => {
            // console.log(this.storage.get('token'));
            this.token = token;
            this.storage.set('token', this.token).then(() => {
                console.log('store token in storage db');
                // console.log(this.storage.get('token'));
            });
        });
    }

    /** logout user and remove localstorage information auth  **/
    async logout(): Promise<void> {
        new Promise(resolve => {
            this.alertService.confirmOkButton = () => {
                this.storage.remove('user').then(() => {
                    this.storage.remove('token').then(() => {
                        this.user = null;
                        this.token = null;
                        this.storage.remove('current-package').then(() => {
                            this.currentPackageInfo = null;
                            this.currentPackageSubject.next(this.currentPackageInfo);
                            this.router.navigate(['/login']).then(() => {
                                // location.reload();
                            });
                        });
                    });
                });
            };

            this.alertService.confirmCancelButton = () => {
            };

            this.alertService.confirmYesNo('آیا می خواهید از برنامه خارج شوید؟').then();

        });
    }

    async forceLogout(): Promise<void> {
        new Promise(resolve => {
            this.storage.remove('user').then(() => {
                this.storage.remove('token').then(() => {
                    this.user = null;
                    this.token = null;
                    this.storage.remove('current-package').then(() => {
                        this.currentPackageInfo = null;
                        this.currentPackageSubject.next(this.currentPackageInfo);
                        this.router.navigate(['/login']).then(() => {
                            // location.reload();
                        });
                    });
                });
            });
        });
    }
}
